import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../shared/components/Button';
import { ButtonsGroup } from '../../shared/components/ButtonsGroup';
import { OllieFloating } from '../../shared/components/OllieFloating';
import { SpeechBubble } from '../../shared/components/SpeechBubble';
import { ROUTES } from '../../shared/routing/routes';
import { useOnboardingStore } from './hooks/useOnboardingStore';

export const OcdCycleIntro = () => {
    const navigate = useNavigate();
    const [currentState, setCurrentState] = useState(0);
    const [disableButton, setDisableButton] = useState(true);
    const setCurrentStep = useOnboardingStore(state => state.setCurrentStep);

    const onboardingStep = 3;

    useEffect(() => {
        setCurrentStep(onboardingStep);
    }, [setCurrentStep]);

    const states = [
        {
            buttonLabel: "Makes sense",
            ollieText: "To start finding relief from OCD, it helps to understand what keeps you stuck in the loop.",
        },
        {
            buttonLabel: "See my loop",
            ollieText: "I've mapped out that loop for you. Therapists call it the OCD cycle.",
        }
    ];

    const handleContinue = () => {
        setDisableButton(true);
        var newState = currentState + 1;
        setCurrentStep(onboardingStep + newState);
        if (newState > 1) {
            navigate(ROUTES.onboarding.ocdCycleExplain);
        } else {
            setCurrentState(newState);
        }
    };

    const handleSpeechBubbleComplete = () => {
        setDisableButton(false);
    };

    return (
        <div className='flex flex-col gap-10 safe-pb-4 px-8 flex-1 overflow-hidden'>
            <title>Ocd Cycle Intro</title>
            <div className='flex-1 flex flex-col justify-center items-center'>
                <div className='flex flex-col items-center justify-end overflow-show h-[250px]'>
                    <SpeechBubble text={states[currentState].ollieText} onTypingComplete={handleSpeechBubbleComplete} />
                    <OllieFloating />
                </div>
            </div>
            <div className="flex flex-col items-center gap-4 flex-shrink-0">
                <ButtonsGroup animated={false}>
                    <Button
                        inactive={disableButton}
                        onClick={handleContinue}
                        label={states[currentState].buttonLabel}
                    />
                </ButtonsGroup>
            </div>
        </div>
    );
};